export default {
	twoTwenty: {
		diesel: {
			productInfo: true,
			name: '220',
			descriptionSubHead: 'Efficient Pickup & Delivery with Peterbilt Class',
			descriptionDetails: 'Designed for driver productivity and uptime.  Ergonomic interior and tight turning radius.  PACCAR PX-7 powertrain.',
			videoLink: 'https://www.youtube.com/embed/SAE5YMufMqM',
			icon: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/220-landing.png`,
			bannerDefault: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/220-banner-w.png`,
			bannerAlt: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/220-banner-w.png`,
			resources: 'https://www.peterbilt.com/static-assets/documents/resources/220_sales_sheet_2019.pdf',
			pdfSize: '4.06 MB - PDF',
			pdfName: '220 Sales Sheet',
			class: 'Medium-Duty',
			fuel: {
				type: 'diesel',
				mileage: 0,
				hours: 2500,
				milesPerGallon: 8,
				gallonsPerHour: 2.5,
				fuelCostPerGallon: 2.60,
			},
			other: {
				costHour: 0,
				annual:0
			},
			equipment: {
				annual: 0,
				costHour: 0,
				vehiclePrice: 0,
				resaleValue: 0,
				amortization: 5,
			},
			maintenance: {
				costPerMile: 0.18,
				costPerHour: 7.04,
			},
			insurance: {
				costPerMile: 0.07,
				costPerHour: 2.68,
			},
			taxes: {
				costPerMile: 0.02,
				costPerHour: 0.90,
			},
			tolls: {
				costPerMile: 0.03,
				costPerHour: 1.34,
			},
			driver: {
				driverWagePerMile: 0.69,
				costPerHour: 27
			}
		},
		electric: {
			productInfo: true,
			name: '220EV',
			descriptionSubHead: 'Smooth, Quiet Pickup & Delivery',
			descriptionDetails: 'Up to 200 miles range on single charge.  Excellent maneuverability.  Class 6 rating with 207 continuous horsepower and Class 7 rating with 347 continuous horsepower.',
			videoLink: 'https://www.youtube.com/embed/o5tUQ2OtFEI',
			rangeType: 'Miles on Full Charge',
			range: '100-200 miles',
			chargingTime: '1-2 hours',
			icon: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/220-landing-ev.png`,
			bannerDefault: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/220ev-banner-w.png`,
			bannerAlt: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/220ev-banner-b.png`,
			resources: 'https://www.peterbilt.com/static-assets/documents/resources/model_220ev_sales_sheet.pdf',
			pdfSize: '15.82 MB - PDF',
			pdfName: '220EV Sales Sheet',
			class: 'Medium-Duty',
			fuel: {
				type: 'electric',
				mileage: 0,
				hours: 2500,
				powerConsumption: 1.35, //154
				electricityCost: 0.123,
				averageSpeed: 65,
				ptoPowerConsumption: 1.35,
				ptoHours: 26.5

			},
			bodyType: {
				bodyParts: [
					{
						id: 0,
						name: 'Van Body Lift Gate',
						bodyAction: 'Number of Lifts Per Day',
						collectionsPerDay: 50,
						bodyPowerConsumption: 1.070
					}
				]
			},
			other: {
				costHour: 0,
				annual:0
			},
			equipment: {
				annual: 0,
				costHour: 0,
				tractorPrice: 0,
				resaleValue: 0,
				purchaseSubsidy: 0,
				amortization: 5,
				chargerPrice: 0,
				vehicleUnits: 6,
				chargerAmortization: 10,
			},
			maintenance: {
				costPerMile: 0.11,
				costPerHour: 7.04,
			},
			insurance: {
				costPerMile: 0.07,
				costPerHour: 2.68,
			},
			taxes: {
				costPerMile: 0.02,
				costPerHour: 0.90,
			},
			tolls: {
				costPerMile: 0.03,
				costPerHour: 1.34,
			},
			driver: {
				driverWagePerMile: 0.69,
				costPerHour: 27
			}
		}
	},
	fiveTwenty: {
		diesel: {
			productInfo: true,
			name: '520',
			descriptionSubHead: 'Rugged, Reliable and Rewarding for Refuse',
			descriptionDetails: 'Durable construction and reliability for the refuse industry.  PACCAR MX-11 powertrain. Residential and Commercial applications.',
			videoLink: 'https://www.youtube.com/embed/fQc2K0uUCvY',
			icon: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/520-landing.png`,
			bannerDefault: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/520-banner-w.png`,
			bannerAlt: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/520-banner-w.png`,
			resources: 'https://www.peterbilt.com/static-assets/documents/resources/model_520_sales_sheet.pdf',
			pdfSize: '5.78 MB - PDF',
			pdfName: '520 Sales Sheet',
			class: 'Vocational',
			fuel: {
				type: 'diesel',
				mileage: 0,
				hours: 2500,
				milesPerGallon: 3,
				gallonsPerHour: 2.5,
				fuelCostPerGallon: 2.60,
			},
			other: {
				costHour: 0,
				annual:0
			},
			equipment: {
				annual: 0,
				costHour: 0,
				vehiclePrice: 0,
				resaleValue: 0,
				amortization: 5,
			},
			maintenance: {
				costPerMile: 0.18,
				costPerHour: 7.04,
			},
			insurance: {
				costPerMile: 0.07,
				costPerHour: 2.68,
			},
			taxes: {
				costPerMile: 0.02,
				costPerHour: 0.90,
			},
			tolls: {
				costPerMile: 0.03,
				costPerHour: 1.34,
			},
			driver: {
				driverWagePerMile: 0.69,
				costPerHour: 27
			},
		},
		electric: {
			productInfo: true,
			name: '520EV',
			descriptionSubHead: 'Zero Emission Refuse Solution',
			descriptionDetails: 'Estimated range of 80 miles with 1,100 bins cycles on single charge.  66,000 pound GVWR. Provides up to 536 continuous and 670 peak horsepower.',
			videoLink: 'https://www.youtube.com/embed/Pvfgtkh0pBU',
			rangeType: 'Miles on Full Charge',
			range: '',
			chargingTime: '',
			icon: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/520-landing-ev.png`,
			bannerDefault: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/520ev-banner-w.png`,
			bannerAlt: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/520ev-banner-b.png`,
			resources: 'https://www.peterbilt.com/static-assets/documents/resources/model_520ev_sales_sheet.pdf',
			pdfSize: '12.78 MB - PDF',
			pdfName: '520EV Sales Sheet',
			class: 'Vocational',
			fuel: {
				type: 'electric',
				mileage: 0,
				hours: 2500,
				powerConsumption: 2.66, //154
				electricityCost: 0.123,
				averageSpeed: 65,
				ptoPowerConsumption: 2.66,
				ptoHours: 52.4
			},
			bodyType: {
				bodyParts: [
					{
						id: 0,
						name: 'Commercial Front Loader',
						bodyAction: 'Number of collections per day',
						collectionsPerDay: 50,
						bodyPowerConsumption: 1.070
					},
					{
						id: 1,
						name: 'Residential Rear Loader with Tipper',
						bodyAction: 'Number of collections per day',
						collectionsPerDay: 50,
						bodyPowerConsumption: 0.240
					},
					{
						id: 2,
						name: 'Residential Automated Side Loader',
						bodyAction: 'Number of collections per day',
						collectionsPerDay: 50,
						bodyPowerConsumption: 0.102
					}
				]
			},
			other: {
				costHour: 0,
				annual:0
			},
			equipment: {
				annual: 0,
				costHour: 0,
				tractorPrice: 0,
				resaleValue: 0,
				purchaseSubsidy: 0,
				amortization: 5,
				chargerPrice: 0,
				vehicleUnits: 6,
				chargerAmortization: 10,
			},
			maintenance: {
				costPerMile: 0.11,
				costPerHour: 7.04,
			},
			insurance: {
				costPerMile: 0.07,
				costPerHour: 2.68,
			},
			taxes: {
				costPerMile: 0.02,
				costPerHour: 0.90,
			},
			tolls: {
				costPerMile: 0.03,
				costPerHour: 1.34,
			},
			driver: {
				driverWagePerMile: 0.69,
				costPerHour: 27
			}
		}
	},
	fiveSeventyNine: {
		diesel: {
			productInfo: true,
			name: '579',
			descriptionSubHead: 'Peterbilt Style, Fuel-Efficiency and Driver Comfort',
			descriptionDetails: 'Superior driver comfort and fuel efficiency. Fully-integrated PACCAR powertrain. On-highway applications.',
			videoLink: 'https://www.youtube.com/embed/Vzt6-ORDJD8',
			icon: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/579-landing.png`,
			bannerDefault: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/579-banner-w.png`,
			bannerAlt: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/579-banner-w.png`,
			resources: 'https://www.peterbilt.com/static-assets/documents/resources/model_520_sales_sheet.pdf',
			pdfSize: '3.62 MB - PDF',
			pdfName: '579 Sales Sheet',
			class: 'On-Highway',
			fuel: {
				type: 'diesel',
				mileage: 0,
				hours: 2500,
				milesPerGallon: 6,
				gallonsPerHour: 2.5,
				fuelCostPerGallon: 2.60,
			},
			other: {
				costHour: 0,
				annual:0
			},
			equipment: {
				annual: 0,
				costHour: 0,
				vehiclePrice: 0,
				resaleValue: 0,
				amortization: 5,
			},
			maintenance: {
				costPerMile: 0.18,
				costPerHour: 7.04,
			},
			insurance: {
				costPerMile: 0.07,
				costPerHour: 2.68,
			},
			taxes: {
				costPerMile: 0.02,
				costPerHour: 0.90,
			},
			tolls: {
				costPerMile: 0.03,
				costPerHour: 1.34,
			},
			driver: {
				driverWagePerMile: 0.69,
				costPerHour: 27
			}
		},
		electric: {
			productInfo: true,
			name: '579EV',
			descriptionSubHead: 'Zero Emissions, Maximum Performance, Driver Comfort',
			descriptionDetails: 'Short and Regional Haul. 80,000 pound GCWR. Estimated range of 150 miles on single charge.  Provides up to 536 continuous and 670 peak horsepower.',
			videoLink: 'https://www.youtube.com/embed/sCYOdQvx8F0',
			rangeType: 'Miles on Full Charge',
			range: '',
			chargingTime: '',
			icon: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/579-landing-ev.png`,
			bannerDefault: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/579ev-banner-w.png`,
			bannerAlt: `${process.env.VUE_APP_ASSET_LOCATION}/vehicles/banners/579ev-banner-b.png`,
			resources: 'https://www.peterbilt.com/static-assets/documents/resources/model_579ev_sales_sheet.pdf',
			pdfSize: '3.62 MB - PDF',
			pdfName: '579EV Sales Sheet',
			class: 'On-Highway',
			fuel: {
				type: 'electric',
				mileage: 0,
				hours: 2500,
				powerConsumption: 2.62, //2.51
				electricityCost: 0.123,
				averageSpeed: 65,
				ptoPowerConsumption: 2.62,
				ptoHours: 106.1
			},
			other: {
				costHour: 0,
				annual:0
			},
			equipment: {
				annual: 0,
				costHour: 0,
				tractorPrice: 0,
				resaleValue: 0,
				purchaseSubsidy: 0,
				amortization: 5,
				chargerPrice: 0,
				vehicleUnits: 6,
				chargerAmortization: 10,
			},
			maintenance: {
				costPerMile: 0.11,
				costPerHour: 7.04,
			},
			insurance: {
				costPerMile: 0.07,
				costPerHour: 2.68,
			},
			taxes: {
				costPerMile: 0.02,
				costPerHour: 0.90,
			},
			tolls: {
				costPerMile: 0.03,
				costPerHour: 1.34,
			},
			driver: {
				driverWagePerMile: 0.69,
				costPerHour: 27
			}
		}
	}
}